import dataLayer from '../dataLayer/reducer';
import grey from '@material-ui/core/colors/grey';
import { TOGGLE_IDUSTRY } from '../mapData/actions';

const USE_COMMON = 'Kopējais';
const USE_HOSEHOLD = 'Mājsaimniecību';
const USE_BUSSINESS = 'Uzņēmumu';

const STYLE = {fontSize: '1em', color: grey[300], borderBottom:'1px solid ' + grey[300] };
const TEXT_STYLE = {color: grey[800]};

export const MODULE_KEY = 'electricUsage';

export const DefaultState = {
    id: 1,
    active: [],
    activeData: [],
    data: [
        {
            id: 'use_common',
            name: USE_COMMON, 
            active: false, 
            layer: 'electric/kopejais_2016', 
            olLayers: [],
            style: {fontSize: '1em', color: grey[300], borderBottom:'1px solid ' + grey[300] },
            textStyle: {color: grey[800]},
            tooltipText: 'Elektroenerģijas patēriņš blīvi apdzīvoto vietu griezumā aprēķināts pēc AS”Sadales tīkls” 2016.g. datiem',
            tooltip: true
        },
        {
            id: 'use_hosehold',
            name: USE_HOSEHOLD,
            active: false, 
            layer: 'electric/Majsaimniecibas_2016', 
            olLayers: [],
            style: {fontSize: '1em', color: grey[300], borderBottom:'1px solid ' + grey[300] },
            textStyle: {color: grey[800]},
            tooltipText: 'Elektroenerģijas patēriņš blīvi apdzīvoto vietu griezumā aprēķināts pēc AS”Sadales tīkls” 2016.g. datiem',
            tooltip: true
        },
        {
            id: 'use_bussiness',
            name: USE_BUSSINESS, 
            active: false, 
            layer: 'electric/Uznemumi_2016', 
            olLayers: [],
            style: {fontSize: '1em', color: grey[300], borderBottom:'1px solid ' + grey[300] },
            textStyle: {color: grey[800]},
            tooltipText: 'Elektroenerģijas patēriņš blīvi apdzīvoto vietu griezumā aprēķināts pēc AS”Sadales tīkls” 2016.g. datiem',
            tooltip: true
        }
    ]
};

class EURDataLayer extends dataLayer {

    reducerExtender(state, action) {    
        
        switch(action.type) {
            case TOGGLE_IDUSTRY:
            case 'sportInfrastructure_TOGGLE_BY_IDS_SINGLE':
            case 'schoolMenu_TOGGLE_BY_IDS_SINGLE':

                var newstate = Object.assign({}, state);
                this.recursiveLoop(newstate.data, (entry)=>{
                    entry.active = false;
                });

                return newstate;
              
            break;
            case 'population_TOGGLE_BY_IDS_SINGLE':
                var newstate = Object.assign({}, state);
                this.recursiveLoop(newstate.data, (entry)=>{
                    if(entry.id === 'middle_school_model') {
                        entry.active = false;
                    }
                });
                
                return newstate;
            break;
        }

    }
}

var electricUsageRed = new EURDataLayer({
  key: MODULE_KEY,
  defaultState: DefaultState
});

const electricUsageExport = electricUsageRed.export();

export const electricUsage = electricUsageExport[MODULE_KEY];
export default electricUsageExport;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/electricUsage/reducer.js